import { useAeThex } from '@/components/AeThexProvider';

export function useSocket() {
  const { socket } = useAeThex();
  return socket;
}

export function useSocketEmit() {
  const { socket } = useAeThex();

  return {
    sendMessage: (channelId, text, userId, userName) => {
      if (socket) {
        socket.emit('message:send', { channelId, text, userId, userName, timestamp: Date.now() });
      }
    },
    emitTyping: (channelId, userId, userName) => {
      if (socket) {
        socket.emit('user:typing', { channelId, userId, userName });
      }
    },
    setUserStatus: (userId, status) => {
      if (socket) {
        socket.emit('user:status', { userId, status });
      }
    },
    sendDirectMessage: (conversationId, text, userId) => {
      if (socket) {
        socket.emit('dm:send', { conversationId, text, userId, timestamp: Date.now() });
      }
    },
    startCall: (roomName, userId, userName) => {
      if (socket) socket.emit('call:start', { roomName, userId, userName });
    },
    endCall: (roomName) => {
      if (socket) socket.emit('call:end', { roomName });
    },
    joinCallRoom: (roomName, userId, userName) => {
      if (socket) socket.emit('call:join', { roomName, userId, userName });
    },
    leaveCallRoom: (roomName, userId) => {
      if (socket) socket.emit('call:leave', { roomName, userId });
    },
  };
}
